module.exports = __webpack_public_path__ + "img/orteils-marteaux.d24ab58f.jpg";